import { FC } from "react";
import { Image as RubicsImage } from "@ludens-reklame/rubics-v3-sdk/file/types";
import { transformImageUrl } from "@ludens-reklame/rubics-v3-sdk/file/utils";

interface Props {
  image?: RubicsImage;
}

const Image: FC<Props> = ({ image }) => {
  if (!image) return;

  return (
    <div className="image-component">
      <div className="mw">
        <img
          src={transformImageUrl(image, { width: 1536 })}
          alt={image.altText}
          style={{ aspectRatio: image.aspectRatio }}
        />
        <p className="b4">{image.caption}</p>
      </div>
    </div>
  );
};

export default Image;
